export default "__VITE_ASSET__CnkyuFX4__"